import { CheckCircleOutlined, ClockCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import {
  PROVISIONING_CHECK_STATUS,
  PROVISIONING_OVERALL_STATUS,
  ProvisioningCheckStatus,
  ProvisioningOverallStatus,
} from '@community_dev/types/lib/api/InfobipProvisioning'
import { Tag } from 'antd'
import type { JSX } from 'react'

type StatusTagProps = {
  status: ProvisioningCheckStatus | ProvisioningOverallStatus
}

export const StatusTag = ({ status }: StatusTagProps): JSX.Element => {
  if (status === PROVISIONING_OVERALL_STATUS.READY_FOR_TRAFFIC) {
    return (
      <Tag color="success" icon={<CheckCircleOutlined />}>
        Ready for Traffic
      </Tag>
    )
  }

  if (status === PROVISIONING_CHECK_STATUS.COMPLETE) {
    return (
      <Tag color="success" icon={<CheckCircleOutlined />}>
        Complete
      </Tag>
    )
  }

  if (status === PROVISIONING_CHECK_STATUS.PENDING) {
    return (
      <Tag color="warning" icon={<ClockCircleOutlined />}>
        Pending
      </Tag>
    )
  }

  if (status === PROVISIONING_CHECK_STATUS.ERROR) {
    return (
      <Tag color="error" icon={<ExclamationCircleOutlined />}>
        Error
      </Tag>
    )
  }

  return <Tag>{status}</Tag>
}
